import { Routes } from '@angular/router';
import { CONTENT_PAGE_SLUGS } from 'app/ui/content-page/content-page.model';
import { WebsiteShellComponent } from './website-shell.component';

export default [
  {
    path: '',
    component: WebsiteShellComponent,
    children: [
      { path: 'home', loadComponent: () => import('./pages/home').then(m => m.HomePage) },
      { path: 'about', loadComponent: () => import('./pages/about').then(m => m.AboutPage) },
      { path: 'agents', loadComponent: () => import('./pages/features').then(m => m.FeaturesPage) },
      { path: 'contact', loadComponent: () => import('./pages/contact').then(m => m.ContactPage) },
      { path: 'faq', loadComponent: () => import('./pages/faq').then(m => m.FaqPage) },
      { path: 'privacy', data: { slug: CONTENT_PAGE_SLUGS.privacy }, loadComponent: () => import('./pages/content-page').then(m => m.WebsiteContentPageComponent) },
      { path: 'terms', data: { slug: CONTENT_PAGE_SLUGS.terms }, loadComponent: () => import('./pages/content-page').then(m => m.WebsiteContentPageComponent) },
      { path: 'thanks', loadComponent: () => import('./pages/thanks').then(m => m.ThanksPage) },
    ],
  },
] satisfies Routes;
